/** likeMap 시딩에 필요한 최소 형태 (평탄화 대상 itemList entity) */
type LikeSeedEntity = Array<{
  item?: { sno?: number; like?: { is_liked?: boolean } };
}>;

/**
 * 서버 entity 의 찜 상태로 likeMap 을 시딩한다. — 순수 변환 함수
 *
 * **이미 likeMap 에 있는 sno 는 기존 값을 유지한다.** 시딩 effect 는
 * effectiveComponents 가 바뀔 때마다(pagination/inject/필터 override) 이미 렌더된
 * 페이지까지 다시 훑는데, entity 의 `like.is_liked` 는 찜 mutation 이 screens 캐시를
 * 패치하지 않아 첫 응답 시점 값에 머문다. 서버값을 나중에 덮으면 사용자가 방금 누른 찜
 * (낙관적 업데이트)이나 `bridge.getLocalGoodsLike` 로 복원한 값이 옛 상태로 되돌아간다.
 *
 * 즉 likeMap 에 값이 있다는 건 "이 세션에서 확인된 더 최신 상태"라는 뜻이라 그걸 살린다.
 */
export const seedLikeMap = (
  prev: Record<string, boolean>,
  entity: LikeSeedEntity,
): Record<string, boolean> => ({
  ...entity.reduce<Record<string, boolean>>((acc, cur) => {
    if (cur.item?.sno != null) {
      acc[cur.item.sno] = cur.item.like?.is_liked ?? false;
    }
    return acc;
  }, {}),
  ...prev,
});